import { checkPermission } from "@/services/utils";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("User", ["userAuth"])
  },
  methods: {
    checkModulePermission(module, permission) {
      if (this.isAdmin()) return true;

      return checkPermission(
        {
          module,
          permission
        },
        this.userAuth.role
      );
    },
    isAdmin() {
      return this.userAuth.role.slug == "ADMIN";
    }
  }
};
